<template>
    <ListPage ref="listPage" :query="query" :total="total" v-loading="loading" :data="tableData"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery"
        @selection-change="handleSelectionChange">
        <template slot="filters">
            <el-form-item label="" prop="search_keyword">
                <el-input v-model="query.search_keyword" placeholder="输入方案名称" clearable
                    @keyup.enter.native="handleSearch" />
            </el-form-item>
            <el-form-item label="分类" prop="category_uuid">
                <PlanCategory v-model="query.category_uuid"></PlanCategory>
            </el-form-item>
        </template>
        <template slot="btns"
            v-if="permission('fagl_falb_fafl') || permission('fagl_falb_pldc') || permission('fagl_falb_xz')">
            <el-button v-if="permission('fagl_falb_fafl')" size="mini" type="primary" @click="handleCategory"> 方案分类
            </el-button>
            <el-button v-if="permission('fagl_falb_pldc')" size="mini" type="primary" @click="handleExport"> 批量导出
            </el-button>
            <el-button v-if="permission('fagl_falb_xz')" size="mini" type="primary" @click="handleAdd"> 新增 </el-button>
        </template>
        <template slot="columns">
            <el-table-column type="selection" width="50" align="center"></el-table-column>
            <el-table-column label="排序" align="center" prop="sort" />
            <el-table-column label="方案名称" align="center" prop="name" />
            <el-table-column label="分类" align="center" prop="category.name" />
            <el-table-column label="创建日期" align="center" prop="create_time" />
            <el-table-column
                v-if="permission('fagl_falb_ck') || permission('fagl_falb_bj') || permission('fagl_falb_sc')" label="操作"
                align="center" width="160">
                <template slot-scope="{ row }">
                    <el-button v-if="permission('fagl_falb_ck')" size="mini" type="text" @click="handleDetail(row)">
                        查看详情 </el-button>
                    <el-button v-if="permission('fagl_falb_bj')" size="mini" type="text" @click="handleEdit(row)"> 编辑
                    </el-button>
                    <el-button v-if="permission('fagl_falb_sc')" size="mini" type="text" @click="handleDel(row)"> 删除
                    </el-button>
                </template>
            </el-table-column>
        </template>
    </ListPage>
</template>

<script>
import { list, del } from "@/api/plan/list";
import listMixin from "@/mixins/list";
import PlanCategory from "@/components/PlanCategory";
import { downloadFileByUrl } from "@/jslibs/utils";

export default {
    components: { PlanCategory },
    data() {
        return {
            list,
            del,
            // 查询参数
            query: {
                search_keyword: "",
                category_uuid: "",
            },
            module: "方案",
            formPath: "/plan/list/form",
            detailPath: "/plan/list/detail",
            uuidKey: "cuuid",
            pick: true,
        };
    },
    mixins: [listMixin],
    mounted() {
        this.search();
    },
    methods: {
        search() {
            this._search();
        },
        handleCategory() {
            this.$router.push({ path: "/plan/category" });
        },
        handleSelectionChange(val) {
            this.ids = val.map((x) => x.uuid);
            this.names = val;
            this.ids_d = this.tableData.filter((x) => this.ids.indexOf(x.uuid) === -1).map((x) => x.uuid);
            this.merge();
        },
        async handleExport() {
            const filename = "方案列表.xlsx";
            const { search_keyword, category_uuid } = this.query;
            const uuids = this.picks.map(x => x.uuid).join();
            downloadFileByUrl(
                process.env.VUE_APP_BASE_URL + `/v1/cms/Mscheme?export=1&search_keyword=${search_keyword}&category_uuid=${category_uuid}&uuids=${uuids}`,
                filename
            );
        },
    },
};
</script>
